import { CHCArticle } from "./article.component.js";
customElements.define("chc-article", CHCArticle);
export {
  CHCArticle
};
//# sourceMappingURL=article.js.map
